let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3ZBM5")).then(() => parcelRequire('iAAbT'));